package com.anjuros.website.templates.template10.modules

import com.anjuros.website.templates.template10.util.ResKey
import com.anjuros.website.templates.template10.util.Template10CompanyDetails

val template10Days = listOf(
    ResKey.TEMPLATE10_CLASS_MON,
    ResKey.TEMPLATE10_CLASS_TUE,
    ResKey.TEMPLATE10_CLASS_WED,
    ResKey.TEMPLATE10_CLASS_THU,
    ResKey.TEMPLATE10_CLASS_FRI,
)

/** One class venue: name + address (company details for placeholders), summary time and weekly slots. */
enum class Template10Venue(
    val number: String,
    val city: Template10CompanyDetails,
    val address: Template10CompanyDetails,
    val summary: ResKey,
    val slots: Map<ResKey, List<String>>
) {
    Venue1(
        number = "一",
        city = Template10CompanyDetails.CLIENTS_SERVICE_AREA1_INFO,
        address = Template10CompanyDetails.CLIENTS_SERVICE_AREA_ADDRESS1_INFO,
        summary = ResKey.TEMPLATE10_SERVICE1_TIME,
        slots = mapOf(
            ResKey.TEMPLATE10_CLASS_MON to listOf("11:00-12:00", "12:00-13:00"),
            ResKey.TEMPLATE10_CLASS_TUE to listOf("11:00-12:00"),
            ResKey.TEMPLATE10_CLASS_WED to listOf("11:00-12:00", "12:00-13:00"),
            ResKey.TEMPLATE10_CLASS_THU to listOf("11:00-12:00"),
            ResKey.TEMPLATE10_CLASS_FRI to listOf("11:00-12:00"),
        )
    ),
    Venue2(
        number = "二",
        city = Template10CompanyDetails.CLIENTS_SERVICE_AREA2_INFO,
        address = Template10CompanyDetails.CLIENTS_SERVICE_AREA_ADDRESS2_INFO,
        summary = ResKey.TEMPLATE10_SERVICE2_TIME,
        slots = mapOf(
            ResKey.TEMPLATE10_CLASS_MON to listOf("16:00-17:00", "17:00-18:00"),
            ResKey.TEMPLATE10_CLASS_TUE to listOf("15:00-16:00"),
            ResKey.TEMPLATE10_CLASS_WED to listOf("16:00-17:00", "17:00-18:00"),
            ResKey.TEMPLATE10_CLASS_THU to listOf("15:00-16:00"),
            ResKey.TEMPLATE10_CLASS_FRI to listOf("16:00-17:00"),
        )
    ),
    Venue3(
        number = "三",
        city = Template10CompanyDetails.CLIENTS_SERVICE_AREA3_INFO,
        address = Template10CompanyDetails.CLIENTS_SERVICE_AREA_ADDRESS3_INFO,
        summary = ResKey.TEMPLATE10_SERVICE3_TIME,
        slots = mapOf(
            ResKey.TEMPLATE10_CLASS_MON to listOf("09:00-10:00"),
            ResKey.TEMPLATE10_CLASS_TUE to listOf("09:00-10:00"),
            ResKey.TEMPLATE10_CLASS_WED to listOf("09:00-10:00"),
            ResKey.TEMPLATE10_CLASS_THU to listOf("09:00-10:00"),
            ResKey.TEMPLATE10_CLASS_FRI to listOf("09:00-10:00"),
        )
    )
}
